export const energyColumns: string[] = ['name', 'movingAddress', 'movingDate', 'energyFlowType', 'fee', 'eanCount', 'detail'];
export const telecomColumns: string[] = ['name', 'movingAddress', 'movingDate', 'detail'];
